import { css } from '@emotion/css';
import React, { lazy, Suspense } from 'react';
import i18n from '../../../i18n';
import { Loading } from '../../shared/Loading';
import { LoadingFailed } from '../../shared/LoadingFailed';
import { TitleHeader } from '../../shared/TitleHeader';

const LicenseContent = lazy(() => import('./LicenseContent'));

export class License extends React.Component<Record<string, unknown>, { hasError?: boolean }> {
  constructor(props: Record<string, unknown>) {
    super(props);
    this.state = { hasError: false };
  }
  public static getDerivedStateFromError(_: any) {
    return { hasError: true };
  }
  public render() {
    const title = i18n.t('settings:license');
    const backLabel = i18n.t('settings:aria_back_to_settings');
    return (
      <main
        className={css`
          display: flex;
          flex-direction: column;
          background: #f5f1e3;
          width: 100%;
          height: 100%;
          font-size: 14px;
          color: #4d3906;
        `}
      >
        <TitleHeader title={title} color="#dbcca7" backLabel={backLabel} />
        {this.state.hasError ? (
          <LoadingFailed error="unstable-network" />
        ) : (
          <Suspense fallback={<Loading />}>
            <LicenseContent />
          </Suspense>
        )}
      </main>
    );
  }
}
